

export const userStore = (state:any) => state.user

export const flashStore = (state:any) => state.flash
